/**
 * Hold shared logics
 */
import { Network } from '@kattana-io/common';

import ethIcon from './images/ETH.svg';
import egldIcon from './images/EGLD.svg';
import bnbIcon from './images/BNB.svg';

interface INetworkBaseCoinIconProps {
  network: Network | undefined;
  className: string;
  motherTokenStyle: any;
}

export const IconsMapping: any = {
  BSC: bnbIcon,
  ELROND: egldIcon,
  ZKSYNC: ethIcon,
  GNOSIS: ethIcon,
  BASE: ethIcon,
  AURORA: ethIcon,
  MANTA: ethIcon,
  LINEA: ethIcon,
  ARBITRUM: ethIcon,
};

const NetworkBaseCoinIcon = ({
  network,
  className,
  motherTokenStyle,
}: INetworkBaseCoinIconProps) => {
  if (!network) {
    return null;
  }

  return (
    <img
      src={IconsMapping[network.getSymbol()] || network.getImage()}
      className={`currency__icon ${className ? className : ''}`}
      style={motherTokenStyle}
    />
  );
};

export default NetworkBaseCoinIcon;
